// extracted by mini-css-extract-plugin
module.exports = {"ant-spin-container":"CreateGroup_ant-spin-container__3Cefe","createGroup":"CreateGroup_createGroup___8cQb","closeButton":"CreateGroup_closeButton__2Wunh"};